import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const GetCodCommissionRanges = (params: { shippingCompanyId: number; pageNumber?: number; pageSize?: number }) => {
    const base = ApiURL.Query.GetCodCommissionRanges;
    const queryParams = new URLSearchParams();
    queryParams.append('ShippingCompanyId', params.shippingCompanyId.toString());
    if (params.pageNumber) queryParams.append('pageNumber', params.pageNumber.toString());
    if (params.pageSize) queryParams.append('pageSize', params.pageSize.toString());
    const url = `${base}?${queryParams.toString()}`;

    return request({
        url,
        method: RequestType.GET,
    });
};

const MPPaymentOnDeliveryCommissionQuery = {
    GetCodCommissionRanges,
};

export default MPPaymentOnDeliveryCommissionQuery;
